import AppController from "../app_controller";
import {
  C_OWNER_REPORT_BRANCH_COVERS,
  C_OWNER_REPORT_DINE_IN,
  C_OWNER_REPORT_DINE_IN_COVERS,
  C_OWNER_REPORT_FILTER,
  C_OWNER_REPORT_PACKAGE_REPORT,
  C_OWNER_REPORT_RATING,
  C_OWNER_REPORT_SERVICE_TYPE,
  C_OWNER_REPORT_SOLD_OUT,
  C_OWNER_REPORT_SOLD_OUT_PER_DATE
} from "../controller_names";

export default class extends AppController {
  // List of controllers instance
  get branchCovers() {
    return this.ctrl(C_OWNER_REPORT_BRANCH_COVERS);
  }

  get dineIn() {
    return this.ctrl(C_OWNER_REPORT_DINE_IN);
  }

  get filter() {
    return this.ctrl(C_OWNER_REPORT_FILTER);
  }

  get packageReport() {
    return this.ctrl(C_OWNER_REPORT_PACKAGE_REPORT)
  }

  get rating() {
    return this.ctrl(C_OWNER_REPORT_RATING)
  }

  get serviceType() {
    return this.ctrl(C_OWNER_REPORT_SERVICE_TYPE)
  }

  get soldOut() {
    return this.ctrl(C_OWNER_REPORT_SOLD_OUT)
  }

  get soldOutPerDate() {
    return this.ctrl(C_OWNER_REPORT_SOLD_OUT_PER_DATE)
  }

  get dineInCovers() {
    return this.ctrl(C_OWNER_REPORT_DINE_IN_COVERS)
  }
}